import { render, staticRenderFns } from "./DatepickerTranslation.vue?vue&type=template&id=3bb4a562"
import script from "./DatepickerTranslation.vue?vue&type=script&lang=js"
export * from "./DatepickerTranslation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports